import React from 'react';
import { ILabelValuePair } from 'types/shared';
import {
  Header,
  StyledTableHead,
  SortingControls,
  HeaderContent,
} from 'components/data-visualization/Table/DropdownHead.style';

interface ITableHeadProps {
  headers: ILabelValuePair<string>[];
  hideVisually?: Set<string>;
}

/**
 * This shows a single header row. Per header the header label is shown, unless the header value
 * is marked as visually hidden by the hideVisually set.
 */
const TableHead: React.FC<ITableHeadProps> = (props) => {
  const { headers, hideVisually } = props;

  return (
    <StyledTableHead>
      <tr>
        {headers.map((head: ILabelValuePair<string>): any => {
          const hide = hideVisually && hideVisually.has(head.value);
          return (
            <Header
              data-hasdropdown={false}
              key={`browse-table-header-${head.value}`}
              id={head.value}
              scope="col"
            >
              <SortingControls>
                <HeaderContent hideVisually={hide}>{head.label}</HeaderContent>
              </SortingControls>
            </Header>
          );
        })}
      </tr>
    </StyledTableHead>
  );
};

export default TableHead;
